module.exports = __webpack_public_path__ + "img/vegetable-taro-190x100.d609cf6a.jpg";